import React from 'react';
import type { UIRouter } from '@uirouter/core';

import type { IRouterMethods, IRouterState } from '../plugins/controller';

interface IRouterContext extends IRouterState, IRouterMethods {
  router: UIRouter;
}

export const RouterContext = React.createContext<IRouterContext>(null!);
